import { Button, type IButtonProps, Icon, Tooltip } from '@lego/klik-ui';
import { PlusBold } from '@lego/klik-ui/icons';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreateDeviceDialog } from './CreateDeviceDialog';

type Props = IButtonProps & {
  workspaceId?: number;
  onCreated?: () => void;
};

export const RegisterDeviceButton = ({ workspaceId, onCreated, ...buttonProps }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(() => searchParams.get('register') === 'true');
  const [initialValues] = useState(() => ({
    serial: searchParams.get('serial') ?? '',
    vendor: searchParams.get('vendor') ?? undefined,
    model: searchParams.get('model') ?? undefined,
    macAddresses: searchParams.getAll('macAddress'),
  }));

  useEffect(() => {
    if (searchParams.get('register') !== 'true') return;
    const nextParams = new URLSearchParams(searchParams);
    for (const key of ['register', 'serial', 'vendor', 'model', 'macAddress']) {
      nextParams.delete(key);
    }
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <>
      <Tooltip label="Create a new device" placement="left">
        <Button
          {...buttonProps}
          leftIcon={<Icon as={PlusBold} />}
          onClick={() => setIsOpen(true)}
          variant="outline"
        >
          Create
        </Button>
      </Tooltip>
      <CreateDeviceDialog
        initialMacAddresses={initialValues.macAddresses}
        initialModel={initialValues.model}
        initialSerial={initialValues.serial}
        initialVendor={initialValues.vendor}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCreated={onCreated}
        workspaceId={workspaceId}
      />
    </>
  );
};
